<!--
 * @Description: 轨迹地图
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-09 19:37:09
 * @LastEditTime: 2020-12-14 16:32:02
-->
<template>
  <div
    id="trackMap"
    class="track-map"
    :style="{ width: width, height: height }"
  ></div>
</template>

<script>
import { initMap } from "e6-base-map/lib/map/mapToolsFun";
export default {
  name: "trackMap",
  props: {
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {
      map: null,
      mapAPI: null,
      lineList: [],
      markerList: [],
      strokeWeight: 6 // 线条宽度
    };
  },
  methods: {
    // 初始化地图
    init() {
      return new Promise((resolve, reject) => {
        initMap("trackMap", "gaode").then(res => {
          if (res == null) {
            reject("初始化地图失败");
            return;
          }
          this.map = res; // 返回并存储 map 对象

          import("e6-base-map/lib/gaode/gaodeAPI.js").then(module => {
            try {
              if (module && module.GaodeAPI) {
                // map 即为 initMap 返回的地图实例对象
                this.mapAPI = new module.GaodeAPI(this.map);
                resolve("地图初始化成功");
              } else {
                reject("引入API文件失败");
              }
            } catch (ex) {
              reject("初始化地图API失败", ex);
            }
          });
        });
      });
    },
    // 获取开始 marker 配置
    addStartMarkerToMap(item) {
      let opts = {
        llObj: { lng84: item.lon, lat84: item.lat },
        icon: require("./ware.png"),
        width: 32,
        height: 41,
        label: item.nodeName || "",
        offsetType: 1 // 图标的偏移方式： 0-图标整体中心；1-图标底部中心
      };
      return opts;
    },
    // 获取结束 marker 配置
    addEndMarkerToMap(item) {
      let opts = {
        llObj: { lng84: item.lon, lat84: item.lat },
        icon: require("../../../../assets/e6Images/navigation/end.png"),
        width: 32,
        height: 40,
        label: item.nodeName || "",
        offsetType: 1 // 图标的偏移方式： 0-图标整体中心；1-图标底部中心
      };
      return opts;
    },
    // 添加点到地图上
    addPointToMap(opts) {
      // 经纬度对象
      let lnglat = this.mapAPI.createLngLat(opts.llObj);
      if (!lnglat) {
        return false;
      }

      let marker = this.mapAPI.createMarker({
        position: lnglat,
        ...opts
      });

      if (marker) {
        this.markerList.push(marker);
        this.mapAPI.addOverlay(marker);
      }
    },
    // 画线
    drawLine(data, color) {
      // 获取点
      let pointArr = data.map(m => {
        return this.mapAPI.createLngLat({
          lng84: m.lon,
          lat84: m.lat
        });
      });

      let trackLine = this.mapAPI.createLine({
        path: pointArr, // 线段路径，数组类型，元素为经纬度对象
        strokeColor: color, // 线路颜色
        strokeOpacity: 1, // 线路透明度,取值范围[0,1]，0表示完全透明，1表示不透明
        strokeWeight: this.strokeWeight, // 线路宽度
        strokeStyle: "solid", // 线路样式，实线:solid，虚线:dashed
        showDir: true, // 是否显示箭头
        clickable: true
      });

      trackLine.path = pointArr;
      trackLine.extData = {
        type: "line"
      };

      this.lineList.push(trackLine);
      this.mapAPI.addOverlay(trackLine);
    },
    // 从地图上移出轨迹线及点
    removeTrackFormMap() {
      this.lineList && this.mapAPI.removeOverlay(this.lineList);
      this.lineList = [];
      this.markList && this.mapAPI.removeOverlay(this.markList);
      this.markList = [];
    },
    // 设置轨迹线到可是范围
    setTrackInView() {
      this.mapAPI.setFitView({ overlayList: this.lineList });
    }
  }
};
</script>

<style lang="scss" scoped></style>
